module.exports = __webpack_public_path__ + "static/media/upload.a97f41e0.svg";